(function ($) {
	var $window = $(window);

	// All Members
	$(function () {
		var page = 1;
		var count = 20;
		var industry = null;
		var startsWith = "";
		var $members = $('.et_pb_module.et_pb_member_all_members');
		var $memberList = null;
		var $selected = null;
		var isDisabled = false;

	
		function AjaxErr(err) {
			console.log(err);
			alert("Sorry, there was an error. Please refresh the page and try again.");
		}

		// Filter items by char
		$members.on('click', '.ld-alphabetical-pagination-all-members a', function (e) {
			e.preventDefault();

			var char = $(this).attr('data-char');
			$members.trigger('ld-alphabetical-pagination-all-members', [char]);
		});

		$members.on('ld-alphabetical-pagination-all-members', function (e, char) {
			if ($members.hasClass('loading')) {
				return;
			}

			//Reset page count as we're doing a new filter
			page = 1;
			isDisabled = false;
			startsWith = char ? char : "";

			$members.addClass('loading');

			//Deselected previous filter
			if (!$selected) {
				$selected = $('.ld-alphabetical-pagination-all-members a.selected');
			}
			$selected.removeClass('selected');
			// Reset scroll message for new filter
			$members.find('.load-more h4').text("Scroll To Load More");

			$.ajax({
				url: window.ld.homeUrl + '/wp-admin/admin-ajax.php?action=AllMembers_GetMembers',
				method: 'POST',
				data: {
					'count': count,
					'page': page,
					'industry': industry || $('.et_pb_module.et_pb_member_all_members .ld-members').attr('data-industry'),
					'subIndustry': $('.et_pb_module.et_pb_member_all_members .ld-members').attr('data-sub-industry'),
					'state': $('.et_pb_module.et_pb_member_all_members .ld-members').attr('data-state'),
					'startsWith': startsWith
				}
			}).then(function (res) {
				if (!res.success) {
					return AjaxErr(res);
				}

				if (res.result.html) {
					//Set new 'selected' char
					$selected = $('.ld-alphabetical-pagination-all-members a[data-char="' + startsWith + '"]');
					$selected.addClass('selected');

					var members = res.result.html;
					var membersCount = $(members).find(".member").length;

					if (!$memberList) {
						$memberList = $members.find('.ld-members');
					}

					if (membersCount <= 0 && page === 1) {
						isDisabled = true;
						$members.find('.load-more h4').text("");
						$memberList.html(members);
						return;
					}

					//Overwrite member list as we're doing a new filter
					$memberList.html(members);
				}
			}, AjaxErr).always(function () {
				$members.removeClass('loading');
			});
		});

		$window.on('scroll', function (ev) {
			if ((window.innerHeight + window.pageYOffset) >= (document.body.offsetHeight - 100)) {
				if ($members.length <= 0 || $members.hasClass('loading')) {
					return;
				}
				page++;
				$members.trigger('ld-load-members');
			}
		});

		$members.on('ld-load-members', function () {

			if (isDisabled) {
				return;
			}

			$members.addClass('loading');
			$.ajax({
				url: window.ld.homeUrl + '/wp-admin/admin-ajax.php?action=AllMembers_GetMembers',
				method: 'POST',
				data: {
					'count': count,
					'page': page,
					'industry': industry || $('.et_pb_module.et_pb_member_all_members .ld-members').attr('data-industry'),
					'subIndustry': $('.et_pb_module.et_pb_member_all_members .ld-members').attr('data-sub-industry'),
					'state': $('.et_pb_module.et_pb_member_all_members .ld-members').attr('data-state'),
					'startsWith': startsWith
				}
			}).then(function (res) {
				if (!res.success) {
					return AjaxErr(res);
				}

				var members = res.result.html;
				var membersCount = $(members).find('.member').length;

				if (membersCount <= 0) {
					isDisabled = true;
					$members.find('.load-more h4').text("No more members");
					return;
				}

				if (!$memberList) {
					$memberList = $members.find('.ld-members');
				}

				if (members) {
					$memberList.append(members);
				}

			}, AjaxErr).always(function () {
				$members.removeClass('loading');
			});
		});
	});
})(jQuery);
